module.exports = __webpack_public_path__ + "static/media/clipboard.ff6c4037.svg";